<div class="sp-order-details-decido__grid sp-min-height__full">
  <app-order-details-decido-bd1
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-decido-bd1>

  <app-order-details-decido-info
    *ngIf="!is_read_running"
    class="sp-order-details-decido__info"
    [order]="order"></app-order-details-decido-info>

  <app-order-details-decido-bd2
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-decido-bd2>

  <app-order-details-decido-bd5
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-decido-bd5>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-decido__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-decido__info sp-order-details-decido__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-decido__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-decido__loading"></app-loading>
</div>
